function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconMy = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M18.386 11.2H0L6.346 0a5.67 5.67 0 0 0 3.115.929 5.7 5.7 0 0 0 2.711-.688L18.384 11.2z",
  "data-name": "Subtraction 7",
  style: {
    strokeLinejoin: "round",
    stroke: "#000",
    strokeWidth: "1.3px",
    fill: "none"
  },
  transform: "translate(6.802 15.169)"
}), /*#__PURE__*/React.createElement("g", {
  style: {
    stroke: "#000",
    strokeWidth: "1.3px",
    fill: "none"
  }
}, /*#__PURE__*/React.createElement("circle", {
  cx: 5.677,
  cy: 5.677,
  r: 5.027,
  "data-name": "Ellipse 5",
  style: {
    fill: "none"
  },
  transform: "translate(10.584 5.501)"
})));
export default SvgIconMy;